import React, {useEffect, useState} from 'react';

const CheckBoxIcon = ({smallIcons, item, setSelectedDownloadItems, selectedDownloadItem}) => {
    const activeCheckBox = (state) => {

        if (state) {
            setSelectedDownloadItems(prevSelected => ({...prevSelected, [item.id]: item}));
        } else {
            setSelectedDownloadItems(prevSelected => {
                let state = {...prevSelected};
                delete state[item.id];
                return state;
            });
        }
    }
    if (smallIcons) {

        return (
            <span style={{cursor: 'pointer'}}>
                {selectedDownloadItem && selectedDownloadItem[item.id]
                    ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                         onClick={() => activeCheckBox(false)}>
                        <path fill="#AF001E" fillRule="evenodd"
                              d="M18.75 1.25v17.5H1.25V1.25h17.5zm-3.181 4.047l-7.956 7.955-2.21-2.21-.883.882 2.211 2.21-.001.001.881.882.002-.001v.001l.883-.882v-.001l7.954-7.956-.881-.881z"/>
                    </svg>
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                         onClick={() => activeCheckBox(true)}>
                        <path fill="#3E3F60" fillRule="evenodd"
                              d="M18.75 1.25v17.5H1.25V1.25h17.5zM17.5 2.5h-15v15h15v-15z"/>
                    </svg>
                }
            </span>
        );
    }

    return (
        <span style={{cursor: 'pointer'}}>
            {selectedDownloadItem && selectedDownloadItem[item.id]
                ?

                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29"
                     onClick={() => activeCheckBox(false)}
                >
                    <path fill="#AF001E" fillRule="evenodd" d="M26.25 1.813v24.5H1.75v-24.5h24.5zm-4.454 5.665L10.658 18.616 7.563 15.52l-1.235 1.235 3.096 3.094-.002.002 1.234 1.235.002-.003.001.003 1.235-1.235-.002-.002L23.03 8.712l-1.234-1.234z"/>
                </svg>

                :
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29"
                     onClick={() => activeCheckBox(true)}
                >
                    <path fill="#3E3F60" fillRule="evenodd" d="M26.25 1.813v24.5H1.75v-24.5h24.5zm-1.75 1.75h-21v21h21v-21z"/>
                </svg>
            }
        </span>
    )

};
CheckBoxIcon.defaultProps = {
    smallIcons: true
}
export default CheckBoxIcon;
